module.exports = __webpack_public_path__ + "img/app-store-btn.a0ddc007.svg";